import { Stack } from "@mui/system";
import {
  colors,
  spacing,
  typography,
} from "../../../../../../../assets/styles/tokens";
import TrendsMobileFilterBy from "./TrendsMobileFilterBy";
import {
  DateRangePicker,
  LocalizationProvider,
  SingleInputDateRangeField,
} from "@mui/x-date-pickers-pro";
import dayjs from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  clearFilterMobileDataMap,
  resetMobileFilters,
} from "../../../../../../../features/trendsSlice";
import { removeTrendParams } from "../../helpers/funcs/filterURLRemove";
import {
  removeParamsFromList,
  timeUnitParams,
} from "../../helpers/funcs/timeUnitParams";
import { useTrackOpen } from "../../helpers/hooks/useTrackOpen";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import { InputAdornment } from "@mui/material";
const TrendsMobileSortWrap = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const { loadingTrendsMobData } = useSelector((state: any) => state.trends);
  const dispatch = useDispatch();
  const startDate = searchParams.get("startDateTM");
  const endDate = searchParams.get("endDateTM");
  const value: [any, any] = [
    startDate ? dayjs(startDate) : null,
    endDate ? dayjs(endDate) : null,
  ];

  const handleAccept = (newValue: any) => {
    dispatch(resetMobileFilters());
    dispatch(clearFilterMobileDataMap());
    if (!newValue || !newValue[0] || !newValue[1]) return;
    setSearchParams((prev) => {
      let updated = removeTrendParams(prev);
      updated = removeParamsFromList(updated, timeUnitParams);
      updated.set("startDateTM", newValue[0].format("YYYY-MM-DD"));
      updated.set("endDateTM", newValue[1].format("YYYY-MM-DD"));
      return updated;
    });
  };
  const trackOpen = useTrackOpen();
  return (
    <>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          mb={spacing.Spacing.md.$value}
        >
          <DateRangePicker
            value={value}
            disabled={loadingTrendsMobData}
            onAccept={handleAccept}
            onChange={() => {}}
            onOpen={() => trackOpen("701")}
            format="DD/MM/YYYY"
            slots={{ field: SingleInputDateRangeField }}
            slotProps={{
              textField: {
                size: "small",
                InputProps: {
                  endAdornment: (
                    <InputAdornment position="end">
                      <CalendarMonthIcon
                        sx={{
                          fontSize: typography.Size.Text.lg.$value,
                          color: colors.GrayLightMode[400].$value,
                        }}
                      />
                    </InputAdornment>
                  ),
                },
                sx: {
                  width: "75%",
                  "& .MuiInputBase-input": {
                    fontSize: typography.Size.Text.sm.$value,
                    lineHeight: typography.Line_height.text.sm.$value,
                    fontWeight: typography.Font_weight.Semibold.$value,
                  },
                  "& .MuiOutlinedInput-root": {
                    borderRadius: spacing.Radius.md.$value,
                    "&.Mui-focused fieldset": {
                      borderColor: colors.GrayLightMode[300].$value,
                      borderWidth: "1px",
                    },
                  },
                },
              },
              actionBar: {
                actions: ["cancel", "accept"],
                sx: {
                  "& .MuiButton-root": {
                    color: "secondary.main",
                  },
                },
              },
            }}
          />
          <TrendsMobileFilterBy />
        </Stack>
      </LocalizationProvider>
    </>
  );
};

export default TrendsMobileSortWrap;
